import React from "react";
import WeddingInvitation from "./routes";

const App = () => {
  return <WeddingInvitation />;
};

export default App;
